import { render, staticRenderFns } from "./IconWorkspacePremium.vue?vue&type=template&id=3d7dc2b4"
import script from "./IconWorkspacePremium.vue?vue&type=script&lang=js"
export * from "./IconWorkspacePremium.vue?vue&type=script&lang=js"
import style0 from "./IconWorkspacePremium.vue?vue&type=style&index=0&id=3d7dc2b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports